import isNull from '../../../../utils/NullChecking';
import { IconAngleBottom, IconAngleRight } from '../../../shared/IconsComponent/icons';
function CellExpanderFormatter({ isCellSelected, expanded, onCellExpand, ClaimLines, tabIndex }) {
    function handleKeyDown(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onCellExpand();
        }
    }
    return (
        <div onClick={() => onCellExpand()} onkeydown={handleKeyDown}>
            <span tabIndex={tabIndex}>
                {expanded ? <span> <IconAngleRight /> {!isNull(ClaimLines) ? `(${ClaimLines})` : ''}
                </span> :
                    <span>  <IconAngleBottom />  {!isNull(ClaimLines) ? `(${ClaimLines})` : ''} </span>}
            </span>
        </div>
    );
}
export default CellExpanderFormatter